import React from 'react';
import './BoardBar.scss';

function BoardBar() {
  return <nav className='board_bar'>Drag and drop to reorder list</nav>;
}

export default BoardBar;
